module.exports = __webpack_public_path__ + "img/Intersection 1.ba606996.png";